import React, {Component} from 'react';
import PropTypes from 'prop-types'
import {minHeight} from "styled-system";
import styled from 'styled-components'
import {withFirebase} from "../Firebase";
import {Box, Card, Flex} from 'rebass';
import PostDetails from '../../pages/PostDetails';
import moment from 'moment';

const Post = styled(Card)`
	${minHeight}
	width: 100%;
`
const Wrapper = styled(Flex)`
	${minHeight}
	//min-height: 91px;
`

class PostCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			owner: {first_name: '', last_name: '', id: 1},
			open: false,
			faculty: [],
			loading: true,
			width: 0, height: 0,
		};
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
	}

	componentDidMount() {
		this.fetchOwnerInfo();
		//this.fetchFacultyList();
		this.setState({loading: false})
		window.addEventListener('resize', this.updateWindowDimensions);
		this.updateWindowDimensions();
	}
	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
		this.updateWindowDimensions();
	}

	updateWindowDimensions() {
		this.setState({width: window.innerWidth, height: window.innerHeight});
	}

	fetchOwnerInfo = async () => {
		const {post, firebase} = this.props;
		try {
			if (post.creator_is_student) {
				let studentRef = await firebase.student(post.creator_uid).get();

				const data = {id: studentRef.id, ...studentRef.data()};
				this.setState({owner: data})
			} else {
				let studentRef = await firebase.faculty(post.creator_uid).get();

				const data = {id: studentRef.id, ...studentRef.data()};
				this.setState({owner: data})
			}
		} catch (e) {
			//console.log(e)
		}
	};

	fetchFacultyList = async () => {
		try {
			let faculty = [];
			let facultyRef = await this.props.firebase.faculties().get();
			facultyRef.docs.forEach(doc => faculty.push({id: doc.id, ...doc.data()}));
			this.setState({faculty, loading: false})
		} catch (error) {
			//console.log(error)
		}
	};

	toggleOpen = () => {
		const {open} = this.state;
		this.setState({open: !open})
	}

	audienceString = (post, school) => {
		let audience = 'All Students'
		let result = []
		if (post.gender_tag.length > 0) {
			let genderResult = post.gender_tag.map(item => item === 'M' ? "Male" : "Female").join(', ')
			result.push(genderResult)
		}
		if (post.grade_tag.length > 0) {
			let gradeResult = post.grade_tag.map(item => item === '3' ? item + 'rd Form' : item + 'th Form').join(', ')
			result.push(gradeResult)
		}
		if (post.dorm_tag.length > 0) {
			let dormResult = post.dorm_tag.map(item => school.dorms.filter(obj => obj.id === item)[0].name).join(', ')
			result.push(dormResult)
		}
		if (result.length > 0) {
			audience = result.join(', ')
		}
		return audience;
	};

	newAudienceString = (post, school) => {
		let results = [];

		if (post.generalStudent === 'All') {
			results.push('All Students')
		} else if (post.generalStudent === 'None') {
		} else {
			let student = [];
			if (post.gender_tag.length > 0) {
				let genderResult = post.gender_tag.map(item => item === 'M' ? "Male" : "Female").join(', ')
				student.push(genderResult)
			}
			if (post.grade_tag.length > 0) {
				let gradeResult = post.grade_tag.map(item => item === '3' ? item + 'rd Form' : item + 'th Form').join(', ')
				student.push(gradeResult)
			}
			if (post.dorm_tag.length > 0) {
				let dormResult = post.dorm_tag.map(item => school.dorms.filter(obj => obj.id === item)[0].name).join(', ')
				student.push(dormResult)
			}

			if (student.length === 0) {
				results.push('All Students')
			} else {
				let text = `Students (${student.join(', ')})`;
				results.push(text);
			}
		}

		if (post.generalFaculty === 'All') {
			results.push('All Faculty');
		} else if (post.generalFaculty === 'None') {
		} else {
			let faculty = [];
			if (post.gender_faculty != null && post.gender_faculty.length > 0) {
				let genderResult = post.gender_faculty.map(item => item === 'M' ? "Male" : "Female").join(', ')
				faculty.push(genderResult)
			}
			
			if (faculty.length === 0) {
				results.push('All Faculty');
			} else {
				let text = `Faculty (${faculty.join(', ')})`;
				results.push(text);
			}
		}

		if (results.length > 1) {
			return results.join(' & ');
		} else {
			return results;
		}
	}



	render() {
		const {owner} = this.state;
		const { post, profile, showStatus, hideName, school, pinnedPost, ...rest } = this.props;
		const date = moment.unix(post.post_time).calendar();
		let name = owner.first_name + ' ' + owner.last_name;
		if (post.creator_uid === profile.id) {
			name = 'Me'
		}
		// name = name + ' -> ' + this.audienceString(post, school);
		name = name + ' -> ' + this.newAudienceString(post, school);

		const { loading, faculty } = this.state;
		return (
			<div>
				<Box>
					<Post variant='post' pt={3} py={3} my={[0]} mx={[0]} width={[0.95]} {...rest}>
						<Wrapper flexDirection={'column'} flexWrap={'wrap'} justifyContent={'space-between'}>
							<PostDetails
								{...this.props}
								post={post}
								faculty={faculty}
								loading={loading}
								formatName={name}
								formatDate={date}
								hideName={hideName}
								pinnedPost={pinnedPost}
							/>
						</Wrapper>
					</Post>
				</Box>
			</div>
		)
	}
}

PostCard.propTypes = {
	post: PropTypes.object,
	profile: PropTypes.object,
	showStatus: PropTypes.bool,
	hideName: PropTypes.bool
};

PostCard.defaultProps = {
	showStatus: false,
	hideName: false
};


export default withFirebase(PostCard);

